import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getFeedbackRead } from '@/api/directoryManagement';
import { getMyFeedback, createFeedback } from '@/views/downLoadCenter/api/api';
import FeedbackDialog from '@/views/downLoadCenter/feedbackDialog.vue';
export default {
  name: "myFeedbackList",
  components: {
    FeedbackDialog: FeedbackDialog
  },
  data: function data() {
    return {
      form: {
        feedback_content: '',
        user_id: '',
        deal_by: '',
        deal_status: '',
        created_at: [],
        id: '',
        page: 1,
        page_size: 50
      },
      dataList: [],
      pages: {},
      statusList: [{
        id: '',
        name: '全部'
      }, {
        id: '0',
        name: '未解决'
      }, {
        id: '1',
        name: '已解决'
      }],
      addForm: {}
    };
  },
  created: function created() {
    this.getDate();
  },
  methods: {
    clean: function clean() {
      this.$refs.form.resetFields();
    },
    handleFeedback: function handleFeedback() {
      var event = this.$refs.feedbackDialog;
      event.dialogVisible = true;
    },
    getList: function getList() {
      this.getDate();
    },
    getDate: function getDate() {
      var _this = this;
      var params = _objectSpread({}, this.form);
      getMyFeedback(params).then(function (res) {
        _this.dataList = res.data.list;
        _this.pages = res.pages;
      });
    },
    getSearch: function getSearch() {
      this.form.page = 1;
      this.getDate();
    },
    sizeChange: function sizeChange(size) {
      this.form.page_size = size;
      this.getDate();
    },
    currentChange: function currentChange(current) {
      this.form.page = current;
      this.getDate();
    }
  }
};